module.exports = __webpack_public_path__ + "static/bg_solutions_tourism.7c32de7d.jpg";